import React from "react";
import PropTypes from "prop-types";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faCoins,
  faLayerGroup,
  faRocket,
  faSliders,
} from "@fortawesome/free-solid-svg-icons";
import styles from "./ValuePropositionSection.module.css";

const features = [
  {
    icon: faLayerGroup,
    title: "Schlanke Lösungen",
    description:
      "Nur das, was Sie wirklich brauchen. Keine unnötigen Features, keine Komplexität, die bremst.",
  },
  {
    icon: faCoins,
    title: "Geringe Kosten",
    description:
      "Keine teuren Lizenzen oder überdimensionierten Systeme. Sie zahlen nur für echten Nutzen.",
  },
  {
    icon: faRocket,
    title: "Schnelle Ergebnisse",
    description:
      "Kurze Analyse, klare Hebel, direkte Umsetzung. Ergebnisse in Wochen statt Monaten.",
  },
  {
    icon: faSliders,
    title: "Volle Kontrolle",
    description:
      "Transparente Architektur, keine Vendor-Lock-ins. Ihre IT bleibt in Ihrer Hand.",
  },
];

function ValuePropositionSection({ openContactForm }) {
  return (
    <section className={styles.section}>
      <div className={styles.layout}>
        <div className={styles.content}>
          <p className={styles.label}>
            <span className="accent-underline">Warum</span> sich Kunden für uns
            entscheiden
          </p>
          <h2 className={styles.headline}>
            Innovative Lösungen über den Standard hinaus
          </h2>
          <p className={styles.description}>
            Wir helfen unseren Kunden, das volle Potenzial ihrer IT zu nutzen -
            indem wir vorhandene Daten gezielt einsetzen und Lösungen
            entwickeln, die exakt zu ihren Anforderungen passen. So reduzieren
            wir Kosten und schaffen Systeme, die wirklich genutzt werden.
          </p>
          <button className={styles.button} onClick={openContactForm} type="button">
            Jetzt starten
          </button>
        </div>

        <div className={styles.featureGrid}>
          {features.map((feature) => (
            <article className={styles.featureCard} key={feature.title}>
              <div className={styles.featureHeader}>
                <div className={styles.iconWrap}>
                  <FontAwesomeIcon icon={feature.icon} className={styles.icon} />
                </div>
                <h3 className={styles.featureTitle}>{feature.title}</h3>
              </div>
              <p className={styles.featureDescription}>{feature.description}</p>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}

ValuePropositionSection.propTypes = {
  openContactForm: PropTypes.func.isRequired,
};

export default ValuePropositionSection;
